import React, { useEffect, useRef, useState } from "react";
import { motion, useInView } from "framer-motion";
import { STATS } from "@/data";

const parse = (v) => {
  const num = parseFloat(v.replace(/[^0-9.]/g, ""));
  return isNaN(num) ? null : num;
};

const Counter = ({ target, suffix }) => {
  const [val, setVal] = useState(0);
  const ref = useRef(null);
  const inView = useInView(ref, { once: true });

  useEffect(() => {
    if (!inView || target == null) return;
    let raf;
    const start = performance.now();
    const dur = 1600;
    const tick = (now) => {
      const p = Math.min((now - start) / dur, 1);
      const eased = 1 - Math.pow(1 - p, 3);
      setVal(target * eased);
      if (p < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [inView, target]);

  const display = Number.isInteger(target) ? Math.round(val) : val.toFixed(1);
  return <span ref={ref}>{display}{suffix}</span>;
};

export const Stats = () => (
  <section className="border-y border-white/10 bg-background">
    <div className="mx-auto grid max-w-[1400px] grid-cols-2 md:grid-cols-4">
      {STATS.map((s, i) => {
        const num = parse(s.value);
        const suffix = s.value.replace(/[0-9.]/g, "");
        return (
          <motion.div
            key={s.label}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7, delay: i * 0.1 }}
            data-testid={`stat-${i}`}
            className={`px-6 py-14 md:py-20 ${i < STATS.length - 1 ? "md:border-r border-white/10" : ""} ${i < 2 ? "border-b border-white/10 md:border-b-0" : ""} ${i % 2 === 0 ? "border-r border-white/10 md:border-r" : ""}`}
          >
            <div className="font-serif text-5xl font-light text-white md:text-6xl">
              {num != null ? <Counter target={num} suffix={suffix} /> : s.value}
            </div>
            <div className="mt-3 text-xs uppercase tracking-[0.2em] text-zinc-500">{s.label}</div>
          </motion.div>
        );
      })}
    </div>
  </section>
);
